import React, { useEffect, useRef } from "react";
import { HashRouter, Navigate, Route, Routes } from "react-router-dom";
import "./App.css";

import "@splidejs/react-splide/css";
import queryString from "query-string";
import socketIOClient from "socket.io-client";
import { environment } from "./environments/Environment";
import { appStore } from "./stores/appStore";
import { sessionService } from "./services/Session/SessionService";

import AppContainer from "./components/AppContainer/AppContainer";
import Matches from "./pages/Matches/Matches";
import Results from "./pages/Results/Results";
import PointsTable from "./pages/PointsTable/PointsTable";
import Live from "./components/Live/Live";
import { GameTable } from "./components/GameTable/GameTable";
import BetHistory from "./components/BetHistory/BetHistory";
import i18n from "./i18n";
import leaguesData from "./config.json";
import { createGlobalStyle, ThemeProvider } from 'styled-components';
import { getTheme } from './themes';

function App() {
  const {
    currentLeague,
    leagueName,
    setCurrentSeason,
    setLiveWeekNumber,
    setCountDownTimer,
    setGoalScored,
    setCurrencyCode,
    setSessionCurrencyCode,
    setPlayerBalance,
    setBonusConfig,
    setGeneralConfig,
    setOperatorId,
    setLeagueName,
    operatorId,
    setPlayerId,
    setQueryUrlData,
  } = appStore((state) => ({
    currentLeague: state.currentLeague,
    leagueName: state.leagueName,
    liveWeekNumber: state.liveWeekNumber,
    setCurrentSeason: state.setCurrentSeason,
    setLiveWeekNumber: state.setLiveWeekNumber,
    setCountDownTimer: state.setCountDownTimer,
    setGoalScored: state.setGoalScored,
    setCurrencyCode: state.setCurrencyCode,
    setSessionCurrencyCode: state.setSessionCurrencyCode,
    setPlayerBalance: state.setPlayerBalance,
    setBonusConfig: state.setBonusConfig,
    setGeneralConfig: state.setGeneralConfig,
    setOperatorId: state.setOperatorId,
    setLeagueName: state.setLeagueName,
    operatorId: state.operatorId,
    setPlayerId: state.setPlayerId,
    setQueryUrlData: state.setQueryUrlData,
  }));
  const theme = {
    menuItem_BG: '#FFFFFF',
    menuItemSelected_BG: '#FEFFFF',
    menuItem_text: "#4C514B",
    menuItemSelected_text: "#FFFCF9"
  };
  const currentLeagueRef = useRef(currentLeague);
  currentLeagueRef.current = currentLeague;
  useEffect(() => {
    console.log("process.env.REACT_APP_ENV", process.env.REACT_APP_ENV);
    let socketOptions = {};
    if (process.env.REACT_APP_ENV !== "LOCAL") {
      socketOptions = { path: "/vleague/socket.io" };
    }
    const socket = socketIOClient(
      process.env.REACT_APP_WS_END_POINT,
      socketOptions
    );
    socket.on("WEEK_STARTED", () => { });
    socket.on("WEEK_ENDED", () => { });
    socket.on("WEEK_IN_PROGRESS", () => { });
    socket.on("DATA_UPDATED", (data) => {
      let leagueId = currentLeagueRef?.current?.leagueId || 1;
      if (data[leagueId]?.countDownTimer || (Object.prototype.hasOwnProperty.call(data[leagueId], "countDownTimer") && data[leagueId]?.countDownTimer === 0)) {
        setCountDownTimer(data[leagueId].countDownTimer);
      }
      if (data[leagueId]?.currentSeasonNumber) {
        setCurrentSeason(data[leagueId].currentSeasonNumber);
      }
      if (data[leagueId]?.liveWeekNumber) {
        setLiveWeekNumber(+data[leagueId].liveWeekNumber);
      }
    });
    socket.on("GOAL_SCORED", (game) => {
      setGoalScored(game);
    });

    socket.on("WEEK_IN_PROGRESS", () => { });
    console.log("FROM APP JS", window.location.search);
    sessionService.setUserSession(window.location.search);
    let queryParams = queryString.parse(window.location.search);
    setQueryUrlData(queryParams)

    i18n.changeLanguage(`${sessionService?.userSession?.languageCode}`);
    setOperatorId(sessionService?.userSession?.operatorId)
    setSessionCurrencyCode(sessionService?.userSession?.currencyCode)

    initRGSSession();
    return () => socket.disconnect();
  }, []);

  const initRGSSession = async () => {
    try {
      const result = await sessionService.initSession();
      setGeneralConfig(result.data.generalConfig)
      setBonusConfig(result.data.bonusConfig)
      if (result.status === 200) {
        setPlayerId(result?.data?.playerId);
        setCurrencyCode(result?.data?.currencyCode);
        setPlayerBalance(result?.data?.balance);
        setSessionCurrencyCode(result?.data?.currencyCode)
        sessionService.updateSession(result.data);
      }
    } catch (e) {
      setCurrencyCode(sessionService.userSession.currencyCode);
      setPlayerBalance("0.00");
    }
  };
  useEffect(() => {
    const league = leaguesData.leagues.find((league) => league.operatorId === operatorId);
    if (league) {
      setLeagueName(league);
    }
  }, [operatorId, setLeagueName]);

  return (
    <ThemeProvider theme={getTheme(sessionService?.userSession?.operatorId)}>
      <React.Fragment>
        <HashRouter>
          <Routes>
            <Route path="/" element={<AppContainer screen={<Matches page={<GameTable />} />} />} />
            <Route path="/matches/gametable" element={<AppContainer screen={<Matches page={<GameTable />} />} />} />
            <Route path="/matches/live" element={<AppContainer screen={<Matches page={<Live />} />} />} />
            <Route path="/results" element={<AppContainer screen={<Results />} />} />
            <Route path="/pointstable" element={<AppContainer screen={<PointsTable />} />} />
            <Route path="/bethistory" element={<AppContainer screen={<BetHistory />} />} />
          </Routes>
        </HashRouter>
      </React.Fragment>
    </ThemeProvider>

  );
}
export default App;
